import { entity, persistence } from 'simpler-state';
import { AppConfig } from '../config/config';

const assetKey = `${AppConfig.storagePrefix}_assets`;
const exposedCountKey = `${AppConfig.storagePrefix}_exposedCount`;

export const breachAssets: any = entity(null, [persistence(assetKey, {})]);

export const exposedCount: any = entity(null, [persistence(exposedCountKey, {})]);
